import { apiRequest } from "@portal/lib/ky/utils";
import {
  CustomFieldTypes,
  CustomFieldDataResponse,
  CustomFieldEntityType,
} from "@portal/types/entities/custom-field";

export async function getCustomFields(filterType: CustomFieldEntityType) {
  const data = await apiRequest<unknown, CustomFieldDataResponse[]>({
    method: "GET",
    url: `v1/custom-fields/filter-fields/${filterType}`,
  });
  return await data.json();
}

export async function getCustomFieldsBasedOnType(type: CustomFieldTypes) {
  const data = await apiRequest<unknown, CustomFieldDataResponse[]>({
    method: "GET",
    url: `v1/custom-fields/entity-custom-fields/${type}`,
  });
  return await data.json();
}
